import {createTheme} from '@material-ui/core';

const themeMaterialUI = createTheme({
  overrides: {
    MuiTable: {
      root: {
        borderCollapse: 'separate',
        borderSpacing: '0px',
        backgroundColor: '#f7fcff',
      },
    },
    MuiTableHead: {
      root: {
        backgroundColor: '#0077c810', // light blue background
      },
    },
    MuiTableRow: {
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: '#f0f8ff',
        },
        '&:hover': {
          backgroundColor: '#e0f3ff',
        },
      },
    },
    MuiTableCell: {
      root: {
        padding: '0px',
        border: '1px solid #272727ff',
        fontSize: '0.9rem',
      },
      head: {
        fontWeight: 600,
        color: '#1a4767',
        backgroundColor: '#f7fcff',
      },
      body: {
        color: '#333',
      },
      sizeSmall: {
        padding: '2px'
      }
    },
  },
  palette: {
    primary:  {
      main: '#0077c888',
      dark: '#1a4767',
      light: '#f7fcff',
      50: '#0077c8',
      100: '#7ccaff',
      item: '#0077c85e',
      cell: '#0077c899',
    },
    secondary: {
      main: '#e4002b88',
    },
    error: {
      main: '#A02929',
      light: '#e41e15',
    },
    header: {
      main: '#fafafa',
    },
    star: {
      color: '#ffb400',
    },
  },
});

export default themeMaterialUI;
